import { SelectInput, SimpleForm, useGetList } from "react-admin";
import { Row } from "../../misc/Row";
import { FormControlLabel, Switch } from "@mui/material";
import { DUNNING_DRIVING_SCHOOLS_FILTER } from "./DunningDashboard";

export function DunningBoardHeader({
  selectedDrivingSchoolId,
  allDrivingSchoolsId,
  setDrivingSchoolId,
  showPostponed,
  setShowPostponed,
}: {
  selectedDrivingSchoolId: string;
  allDrivingSchoolsId: string;
  setDrivingSchoolId: (id: string) => void;
  showPostponed: boolean;
  setShowPostponed: (show: boolean) => void;
}) {
  const { data: drivingSchools = [] } = useGetList("drivingSchools", {
    filter: DUNNING_DRIVING_SCHOOLS_FILTER,
    pagination: { page: 1, perPage: 9999 },
    sort: { field: "name", order: "ASC" },
  });
  return (
    <Row mx={4}>
      <SimpleForm toolbar={false} sx={{ p: 0 }}>
        <Row gap={3} alignItems="baseline">
          <SelectInput
            label="Fahrschule"
            emptyText={<i>Fahrschule auswählen</i>}
            source="drivingSchoolId"
            value={selectedDrivingSchoolId}
            onChange={(event) => setDrivingSchoolId(event.target.value)}
            choices={[{ id: allDrivingSchoolsId, name: "Alle Fahrschulen laden" }, ...drivingSchools]}
          />
          <FormControlLabel
            control={
              <Switch
                checked={showPostponed}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setShowPostponed(e.target.checked)}
              />
            }
            label="Zeige ausgeblendete Fälle"
          />
        </Row>
      </SimpleForm>
    </Row>
  );
}
